<template>
  <div class="breadcrumb">
    <span class="breadcrumb-item" v-for="(item, index) in items" :key="index">
      <router-link :to="item.url">{{item.name}}</router-link>
      <img class="breadcrumb-separator" src="/static/small-circle.svg" height="4" width="4" />
    </span>
    <span class="breadcrumb-current-item">{{currentItem}}</span>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    items: {
      type: Array,
      default: () => { [{name: '', url: ''}] }
    },
    currentItem: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>
.breadcrumb {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}
.breadcrumb .breadcrumb-item {
  display: flex;
  align-items: center;
}
.breadcrumb .breadcrumb-item a {
  text-decoration: none;
  font-family: 'Paralucent';
  font-size: 12px;
  color: #0C2E4A;
}
.breadcrumb .breadcrumb-item .breadcrumb-separator {
 margin-left: 8px;
 margin-right: 8px;
}
.breadcrumb .breadcrumb-current-item {
  font-family: 'Paralucent';
  font-size: 12px;
  color: #858EA1;
}
</style>


// WEBPACK FOOTER //
// src/components/Breadcrumb.vue